<template>
    <CRow>
        <CCol col>
            <div id="spot-pricing">
                <div class="market-price-padding"></div>
                <ejs-datepicker ref="dateObj" :placeholder="waterMark" v-model="dateVal" :format="dateFormat" :focus='onFocus' :firstDayOfWeek='1' :max='maxVal' width=180></ejs-datepicker>
                <div style="width:100%; height: 80vh;">
                    <ejs-grid ref='grid' :dataSource="spotPricingData" :allowFiltering='true' :allowPaging="true"
                              :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true'
                              :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true' :excelQueryCellInfo='excelQueryCellInfo'
                              :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionBegin='actionBegin' :queryCellInfo='queryCellInfo'
                              :actionComplete='actionComplete' :actionFailure="actionFailure" :query='query' :filterSettings='filterOptions' width="100%" height="100%">
                        <e-columns>
                            <e-column field='spotPricingId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='ricId' headerText='RIC' textAlign='Left' :visible="false" :validationRules="ricRules" editType='dropdownedit' :edit='spotRicParams' foreignKeyValue='ric' foreignKeyField="id" :dataSource='spotRics' width=130></e-column>
                            <e-column field='ricName' headerText='Identifier' textAlign='Left' visible="true" width=150 type="string"></e-column>
                            <e-column field='stateName' headerText='Country' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='utilityTypeName' headerText='Commodity' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='productName' headerText='Product' textAlign='Left' width=180 type="string" :allowEditing="false"></e-column>
                            <e-column field='settlementDate' headerText='Settlement Date' textAlign='Left' :validationRules="requiredRules" :format='dateFormatOptions' type='date' :edit="dpParams" width=150></e-column>
                            <e-column field='description' headerText='Description' textAlign='Left' :allowEditing="false" :visible='true' width=150></e-column>
                            <e-column field='price' headerText='Settlement Price' textAlign='Left' :validationRules="priceRules" type="number" format="n3" editType='numericedit' :edit='numericParams' width=150></e-column>
                            <e-column field='tradingUnitPreview' headerText='Trading Unit' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='createdBy' headerText='Created By' textAlign='Left' :allowEditing="false" width=180 type="string"></e-column>
                            <e-column field='createdDate' headerText='Import Date' textAlign='Left' :allowEditing="false" :format='dateFormatOptions' type='date' width=150></e-column>
                            <e-column field='importDate' headerText='Date' textAlign='Left' :allowEditing="false" :visible='false' width=150></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <div id="spotModalTarget" class="control-section; position:relative" style="height:350px;">
                    <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
                </div>
            </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import authToken from '../../../common/authToken';
    import urls from '../../../common/urls';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions';
    import dates from '../../../common/dates';
    import apis from '../../../common/network';
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DatePickerPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(GridPlugin);
    let spotRicObj, spotRicElem, datePickerObj, elem;
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                maxVal: new Date(),
                waterMark: 'Select a date',
                dateVal: dates.addDays(new Date(),-1),
                format: "dd/MM/yyyy",
                dateFormat: 'dd/MM/yyyy',
                spotRics: SyncHelper.getDataManager('spotConfig/spotConfigRics'),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 4,
                        format: "n4"
                    }
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
                spotPricingData: this.$store.state.permissions["Permissions.SpotPricing.View"] ? SyncHelper.getDataManager("SpotPricing") : [],
                dpParams: {
                    create: function () {
                        elem = document.createElement('input');
                        return elem;
                    },
                    read: () => {
                        return datePickerObj.value;
                    },
                    destroy: () => {
                        datePickerObj.destroy();
                    },
                    write: (args) => {
                        datePickerObj = new DatePicker({
                            value: new Date(args.rowData[args.column.field]),
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            //sets the max. 
                            max: dates.addDays(new Date(), -1),
                            placeholder: 'Settlement Date',
                            firstDayOfWeek: 1
                        });
                        datePickerObj.appendTo(elem);
                    }
                }, 
                spotRicParams: {
                    create: () => {
                        spotRicElem = document.createElement('input');
                        return spotRicElem;
                    },
                    read: () => {
                        return spotRicObj.value;
                    },
                    destroy: () => {
                        spotRicObj.destroy();
                    },
                    write: (args) => {
                          spotRicObj = new DropDownList({
                            dataSource: this.spotRics,
                            allowFiltering: true,
                            showClearButton: true,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            change: (args) => {
                                apis.protectedApi(`${urls.apiBaseUrl}spotConfig/spotConfigRics`).then(it => {
                                    var mappedRic = it.data.filter(function (ric) {
                                        return ric.id == args.value;
                                    });

                                    document.getElementsByName("stateName")[0].value = mappedRic[0].stateName;
                                    document.getElementsByName("utilityTypeName")[0].value = mappedRic[0].utilityTypeName;
                                    document.getElementsByName("productName")[0].value = mappedRic[0].productName;
                                    if (mappedRic[0].pricingAreaId != null) {
                                        document.getElementsByName("priceAreaName")[0].value = mappedRic[0].priceAreaName;
                                    }
                                    else {
                                        document.getElementsByName("priceAreaName")[0].value = "";
                                    }
  
                                }
                                ).catch(
                                    response => {
                                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                        gridOptions.errorAlert("Error: " + message);
                                    }
                                );

                            },
                            placeholder: 'Identifier',
                            floatLabelType: 'Always'

                          });
                        spotRicObj.appendTo(spotRicElem);
                    }
                },
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 100, pageCount: 4 },
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.SpotPricing.Update"],
                    allowAdding: store.state.permissions["Permissions.SpotPricing.Create"],
                    allowDeleting: store.state.permissions["Permissions.SpotPricing.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                priceRules: { required: true, number: true},
                requiredRules: { required: false },
                ricRules: { required: true },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,
                path: {
                    saveUrl: `${urls.apiBaseUrl}SpotPricing/Import/`
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
            this.checkPermissionOnUser();
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {

                }
                gridOptions.excelExport(args, "Spot Pricing.xlsx", this.$refs);
            },
            excelExportComplete(args) {

                this.$refs.grid.hideSpinner();
            },            
            actionBegin(args) {
                gridOptions.actionBegin(args);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "createdBy") {
                          this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "createdDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "importDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        }
                    }
                    this.$refs.grid.getColumns()[1].visible = true;
                    this.$refs.grid.getColumns()[2].visible = false;
                    
                }
                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));


                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "createdBy") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "createdDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "importDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        }
                    }

                    document.getElementsByName("importDate")[0].value = this.dateVal.toISOString().split('T')[0];
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args)
                hideSpinner(document.getElementById('mainSpinner'));
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            //onUploadSuccess: function (args) {
            //    this.$refs.grid.refresh();
            //},
            //onUploadFailed: function (args) {
            //    this.$refs.grid.refresh();
            //    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
            //    args.statusText = statusMessage.trim();
            //}, 
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.grid.refresh();
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
            queryCellInfo(args) {
                if (args.column.field === 'tradingUnitName') {
                    args.cell.textContent =  args.data.currencySymbol + '/' + args.data.tradingUnitName;
                }
                if (args.column.headerText === 'Log Date') {
                    args.cell.textContent = this.formatDate(args.data['logDate']);
                }
            },
            convertUTCDateToLocaDate(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleDateString();
            },
            formatDate(dateString) {
                const date = new Date(dateString)
                return date.toLocaleDateString();
            },
            excelQueryCellInfo: function (args) {
                if (args.column.headerText === 'Log Date') {
                    args.cell.value = this.convertUTCDateToLocaDate(args.data['logDate']);
                }
                if (args.column.field === 'tradingUnitName') {
                    args.value = args.data.currencySymbol + '/' + args.data.tradingUnitName;
                }
            },
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                    this.toolbar = ['Add', 'Edit', 'Delete'];
                    document.getElementById("spotModalTarget").style.display = "none";
                }

            },
        },
        computed: {
            query: function () {
          
                return new Query().addParams("date", this.dateVal.toISOString().split('T')[0]);

            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };
</script>
<style scoped>
    .market-price-padding {
        padding-top: 30px;
    }

</style>
